import * as Sentry from '@sentry/browser';
import './polyfills';
import * as serviceWorker from './serviceWorker';

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({ dsn: process.env.REACT_APP_SENTRY_DSN });
}

if (process.env.REACT_APP_HOTJAR_ID) {
  import(/* webpackChunkName: 'react-hotjar' */ 'react-hotjar')
    .then(({ hotjar }) => {
      hotjar.initialize(process.env.REACT_APP_HOTJAR_ID, 6);
    })
    .catch(error => {
      Sentry.captureException(error);
    });
}

serviceWorker.unregister();
